import React, { Component } from 'react';
import styles from './items.module.css';

export default class SubTitle extends Component {
    render() {
        let {text}= this.props;
        return (
                 <h2 className={styles.sub_title}>{text}</h2>
        );
    }
}

